import { render, staticRenderFns } from "./RecipePublish.vue?vue&type=template&id=81b62c98&"
import script from "./RecipePublish.vue?vue&type=script&lang=js&"
export * from "./RecipePublish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports